<template>
  <div class="container container-l margin-max-vertical">
    <card title="Playground">
      <div class="flex gap-l">
        <form-button @click="testServer">test</form-button>
        <form-button @click="testAction">test local</form-button>
        <form-button @click="loadItems">load items</form-button>
      </div>
      <div class="margin-m-block text-inline-end">
        <span class="force-ltr"> count: {{items?.length}}</span>
      </div>

      <debug :data="items"></debug>
      <s-debug :data="listConf"></s-debug>
      <s-debug :data="items"></s-debug>
      <s-debug :data="folders"></s-debug>

    </card>
  </div>
</template>

<script>
import ChatView from "@/client/views/Chat.vue";
import SupportChat from "@/client/components/chat/SupportChat.vue";
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import useMediaManager from "@/client/extensions/composition/useMediaManager";

export default {
  components: { ChatView, SupportChat },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    let  {
      items,
      folders,
      totalItems,
      hasItems,
      isLoadingItems,
      hasError,
      upload,
      rename,
      resetList,
      refreshListItems,
      loadItems,
      reloadItems,
      reload,
      setFolder,
      setFilter,
      unsetFilter,
      setLimit,
      loadMore,
      resizeImage,
      isImage,
      isResizableImage,
      getFolderName,
      getParentFolder,
      isFolderPathNested,
      listConf,
      setOrder,
    } = useMediaManager(props);
    return { asyncOps, asyncOpsReady, asyncStatus,

      items,
      folders,
      totalItems,
      hasItems,
      isLoadingItems,
      hasError,
      upload,
      rename,
      resetList,
      refreshListItems,
      loadItems,
      reloadItems,
      reload,
      setFolder,
      setFilter,
      unsetFilter,
      setLimit,
      loadMore,
      resizeImage,
      isImage,
      isResizableImage,
      getFolderName,
      getParentFolder,
      isFolderPathNested,
      listConf,setOrder,};
  },
  data: function () {
    return {};
  },
  methods: {
    async testServer() {

      let url = "playground/use-case2";
      let data = {};
      let options = {

      };
      let res = await this.asyncOps.asyncCall(url, data, options);
      //this.asyncOps.clearAllRequestDataFromCache();
// TODO: support caching: 5000,

      // check:
      // cahce: false,
      // cache: true,
      // cache: 5000
      // cache: {
      //ttl: 5*1000
      //}
      console.log("res", res);
      console.log(res.data);
    },
    async testAction() {
      console.log('testAction');
      this.resetList();
      this.setFilter('folder', '/test');
      this.setLimit(1);
      this.setOrder('random');
      this.reloadItems();
      console.log(this.items);
    },
  },
  mounted() {
    // TODO: who runs purge?
   // setInterval(() => {
   //   this.$store.commit('asyncData/purgeExpiredRequestDataCache');
    //},1000);
  }
};
</script>

<style scoped lang="scss"></style>
